<template>
  <div>
    <report-pbi
      report-id="5ccc6e02-e000-45e8-ae88-b13c128d99f0"
      group-id="5de7d4a7-b0d1-41a8-a978-693e831cfdcd"
      page-name="81f800ed-1b96-4732-a9ed-c95ed2ed76c5"
    ></report-pbi>
  </div>
</template>

<script>
import reportPbi from '@/components/organisms/report-pbi/index.vue';

export default {
  components: {
    reportPbi,
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  width: 100px;
  height: 50px;
}
</style>
